module.exports = "::ng-deep .image {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/services-re/services-re.component.scss
// module id = ./src/app/components/services-re/services-re.component.scss
// module chunks = main